import settings from "@settings";


export const divider = {
    small: {
        height: ".5px",
        width: "100%",
        marginTop: settings.sizes.small,
        marginBottom: settings.sizes.small

    },
    medium: {
        height: ".5px",
        width: "100%",
        marginTop: settings.sizes.medium,
        marginBottom: settings.sizes.medium
    },
    large: {
        height: ".5px",
        width: "100%",
        marginTop: settings.sizes.large,
        marginBottom: settings.sizes.large
    }
}


